import React, { useEffect, useRef } from 'react'
import Lottie, { type AnimationConfigWithData } from 'lottie-web'

export const AnimationPlayer = ({
  animationData,
  ...rest
}: Omit<AnimationConfigWithData, 'container'>) => {
  const playerContainer = useRef(null)

  useEffect(() => {
    Lottie.loadAnimation({
      autoplay: true,
      loop: true,
      ...rest,
      container: playerContainer.current!,
      animationData: JSON.parse(JSON.stringify(animationData)),
    })
  }, [])

  return <div ref={playerContainer} />
}
